import { CONTACT_SUPPORT_ID } from '../constants';

const onContactSupportClick = (integrationSettings) => {
  integrationSettings.helpMenu.submenu.find((item) => item.id === CONTACT_SUPPORT_ID).onClick();
};

export default onContactSupportClick;
